import { ShieldCheck } from "lucide-react";
import { useAuth } from "../lib/auth";

// Floating indicator shown on every page while the owner is logged in.
// Editing stays on until they log out from /admin.
export function AdminModeChip() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div
      className="fixed bottom-4 left-4 z-50 flex items-center gap-2 px-3 py-1.5 rounded-full bg-deep/95 border border-cyber/40 font-mono text-[10px] text-cyber backdrop-blur-md"
      data-testid="admin-mode-chip"
    >
      <ShieldCheck className="w-3 h-3" />
      ADMIN MODE — hover any text, click to edit. Ends on logout.
    </div>
  );
}
